export default __webpack_public_path__ + "static/media/Vector-1.08d2455f.svg";